var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "860.000000pt",
    height: "860.000000pt",
    viewBox: "0 0 860.000000 860.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,860.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4300 l0 -4300 4300 0 4300 0 0 4300 0 4300 -4300 0 -4300 0 0 -4300z m3880 1790 l651 -859 32 37 c18 20 179 210 358 422 179 212 473 561 654 775 182 215 341 405 355 422 l25 32 468 0 c257 1 467 -1 467 -4 0 -3 -147 -180 -327 -393 -180 -213 -498 -589 -707 -837 -209 -247 -489 -578 -621 -735 -133 -157 -245 -291 -249 -298 -5 -9 47 -86 156 -230 91 -119 389 -514 664 -877 275 -363 697 -921 939 -1240 241 -319 443 -586 448 -592 8 -10 -175 -13 -906 -13 l-915 0 -678 895 c-372 492 -681 895 -685 895 -7 0 -70 -73 -599 -700 -151 -179 -410 -485 -575 -680 -165 -196 -314 -372 -331 -393 l-30 -37 -469 2 -468 3 224 265 c1725 2039 1802 2132 1789 2153 -7 11 -180 241 -384 511 -205 270 -682 901 -1061 1401 -378 501 -692 916 -698 923 -7 9 175 12 906 12 l916 0 651 -860z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2421 6430 c8 -10 255 -338 550 -727 759 -1001 2030 -2680 2367 -3125 l285 -378 284 0 c232 0 283 2 276 13 -7 11 -276 368 -916 1212 -71 94 -264 348 -428 565 -164 217 -451 595 -636 841 -186 245 -538 709 -782 1032 l-445 587 -284 0 c-280 0 -284 0 -271 -20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter2);
export default __webpack_public_path__ + "static/media/twitter2.83ce4cf681b22b8753a4ac2039ba0ed2.svg";
export { ForwardRef as ReactComponent };